import React, { useState } from 'react';
import { DataTable } from '@/components/shared';
import { List } from '@refinedev/antd';
import { endPoints } from '@/api/configs';
import { useList } from '@/hooks/useList';
import { useTranslation } from '@refinedev/core';
import { BookOutlined, ReloadOutlined } from '@ant-design/icons';
import { getColumns } from './columns';
import { ClassesRes } from '@/api/types/getClasses';
import { Form, Select, Button, message } from 'antd';
import useApi from '@/api/useApi';

export const ClassesList = () => {
  const [form] = Form.useForm();
  const [activateId, setActivateId] = useState<string>('');
  const { usePatch } = useApi();
  const { mutate: activateClass, isLoading: activateLoading } = usePatch(
    endPoints.class(activateId)
  );
  const { translate } = useTranslation();
  const {
    data,
    isLoading,
    page,
    setPage,
    isRefetching,
    refetch,
    setFilters,
    resolvedTotal,
  } = useList<{
    data: ClassesRes[];
  }>({
    endpoint: endPoints.listingClasses,
  });

  const handleActivate = (value: boolean) => {
    activateClass(
      { is_active: value },
      {
        onSuccess: () => {
          message.success(
            value
              ? translate('listing-classes.success.activate-class')
              : translate('listing-classes.success.deactivate-class')
          );
          refetch();
        },
        onError: () => {
          message.error(
            value
              ? translate('listing-classes.error.activate-class')
              : translate('listing-classes.error.deactivate-class')
          );
        },
      }
    );
  };
  const columns = getColumns(
    translate,
    refetch,
    handleActivate,
    setActivateId,
    activateId,
    activateLoading
  );
  const onIsActiveChange = (value: boolean) => {
    setPage(1);
    setFilters((prev) => ({
      ...prev,
      is_active: value,
    }));
  };
  const resetFilters = () => {
    form.resetFields();
    setFilters({
      is_active: undefined,
    });
  };
  return (
    <List
      title={
        <div className="flex gap-x-3">
          <BookOutlined />
          <h1>{translate('listing-classes.title')}</h1>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        <div className="flex flex-wrap gap-x-3">
          <Form.Item name="is_active" className="w-full sm:w-1/6 min-w-[200px]">
            <Select
              placeholder={translate('search-user.fields.status')}
              onChange={onIsActiveChange}
              allowClear
              style={{ width: 200 }}
              options={[
                { label: translate('status.active'), value: true },
                { label: translate('status.inactive'), value: false },
              ]}
            />
          </Form.Item>
          <Button
            className="mb-2 sm:mb-0"
            type="primary"
            icon={<ReloadOutlined />}
            onClick={resetFilters}
          />
        </div>
      </Form>
      <DataTable
        pageSize={10}
        currentPage={page}
        onPageChange={setPage}
        columns={columns}
        loading={isLoading || isRefetching}
        data={{
          // @ts-ignore
          data: data?.data.data.classes || [],
          headers: { 'x-total-count': resolvedTotal },
        }}
      />
    </List>
  );
};
